import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "conversations-modal" }
const _hoisted_2 = { class: "conversations-modal__dialog" }
const _hoisted_3 = { class: "conversations-modal__header" }
const _hoisted_4 = {
  key: 0,
  class: "conversations-modal__title"
}
const _hoisted_5 = { class: "conversations-modal__main" }

import { ContactProfile } from '../models/contactProfile';
import { Conversation } from '../models/conversation';
import { conversationApi } from '../services/conversationApi';
import ContactConversationList from './ContactConversationList.vue';
import { useStore } from 'vuex';
import { computed, onMounted, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';


export default /*@__PURE__*/_defineComponent({
  __name: 'ContactConversationModal',
  setup(__props) {

const route = useRoute();
const router = useRouter();
const store = useStore();
const currentWorkspace = computed(() => store.getters.currentWorkspace);

const contactId = ref('');
const loadingContactProfile = ref(false);
const conversations = ref<Conversation[]>([]);
const contactProfile = ref<ContactProfile>();
const contactName = computed(() => contactProfile.value?.name || 'Unknown');

onMounted(async () => {
  contactId.value = <string>route.params.id;
  await loadContactProfile();
});

async function loadContactProfile(): Promise<void> {
  loadingContactProfile.value = true;
  const response = await conversationApi.getContactProfile(currentWorkspace.value.id, contactId.value);
  conversations.value = response.conversations;
  contactProfile.value = response.contact;
  loadingContactProfile.value = false;
}

function closeModal() {
  router.push({ name: 'contacts-list' });
}

return (_ctx: any,_cache: any) => {
  const _component_n_avatar = _resolveComponent("n-avatar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "conversations-modal__backdrop",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (closeModal()))
    }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("header", _hoisted_3, [
        (contactProfile.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(_component_n_avatar, {
                name: contactName.value,
                imageUrl: contactProfile.value.avatarUrl,
                enableTooltip: true
              }, null, 8, ["name", "imageUrl"]),
              _createElementVNode("h2", null, _toDisplayString(contactName.value), 1)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("button", {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (closeModal())),
          class: "delete conversations-modal__close-button",
          "aria-label": "close"
        })
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(ContactConversationList, {
          conversations: conversations.value,
          loading: loadingContactProfile.value,
          workspaceId: currentWorkspace.value.id
        }, null, 8, ["conversations", "loading", "workspaceId"])
      ])
    ])
  ]))
}
}

})